import React from 'react'
import Button from '~/components/_atoms/Button'
import { Audio } from '~/components/icons/YnsIcon'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import translations from './locales.json'

const CoachInsightAudioPlayer = ({ audioUrl, locale }) => {
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={
        'javascript.components.coach_services.CoachInsights.CoachInsightAudioPlayer'
      }
    >
      <CoachInsightAudioPlayerInner audioUrl={audioUrl} />
    </TranslationProvider>
  )
}

const CoachInsightAudioPlayerInner = ({ audioUrl }) => {
  const [listenPressed, setListenPressed] = React.useState(false)
  const { t } = useTranslation()

  return (
    <div className="grid grid-cols-[auto_1fr] gap-3">
      <div>
        <Button
          variant={listenPressed ? 'solid' : 'outline'}
          color="secondary"
          onClick={() => {
            setListenPressed(!listenPressed)
          }}
          endIcon={<Audio className="stroke-current" />}
        >
          {t('listen')}
        </Button>
      </div>
      {listenPressed && (
        <div className="flex justify-between gap-6">
          <audio className="w-full" controls preload="metadata" autoPlay>
            <source src={audioUrl} type="audio/mpeg" />
            {t('audio_not_supported')}
          </audio>
        </div>
      )}
    </div>
  )
}

export default CoachInsightAudioPlayer
